<template>
  <modal
    name="property-pricing"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="992"
    height="auto"
    :clickToClose="false"
    @before-open="getData"
  >
    <div class="modalWrapper">
      <div class="form-row mb-4">
        <div class="col-12">
          <div class="content__box">
            <div class="content__box__header">
              <div class="top__filter">
                <ul class="top__filter__ul">
                  <li class="mb-0">Pricing</li>
                </ul>
              </div>
            </div>
            <div class="content__divider"></div>
            <div class="content__box__body">
              <!-- FORM STARTS HERE -->

              <!-- GRACE PERIOD -->
              <div
                class="
                  row
                  align-items-center
                  pb-3
                  border--bottom-gray
                  no-gutters
                "
              >
                <div class="col-sm-4">
                  <app-toggle
                    :checked="price.grace_period_status"
                    label="Grace Period"
                    @update:checked="getChecked($event, 'grace_period')"
                  ></app-toggle>
                </div>
                <div
                  class="col-sm-8 mt-3 mt-sm-0"
                  v-if="price.grace_period_status"
                  @click="openWindow('grace_period', 0)"
                >
                  <div class="d-flex align-items-center">
                    <p class="txt--xs txt--off-white">Duration</p>
                    <p class="txt--primary txt--xs pt-1 hidden_input">
                      {{ price.grace_period }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Special Rates -->
              <div class="py-3 border--bottom-gray">
                <div v-if="price.special_rate.length > 0">
                  <div
                    class="form-row rate__row align-items-center"
                    v-for="(special_rate, index) in price.special_rate"
                    :key="index"
                  >
                    <div class="col-sm-3">
                      <app-toggle
                        :checked="special_rate.status"
                        :label="
                          special_rate.title.length > 20
                            ? special_rate.title.substring(0, 17) + '...'
                            : special_rate.title
                        "
                        :label_clickable="true"
                        @update:checked="updateSpecialRateStatus($event, index)"
                        @label:clicked="updateSpecialRateLabel(index)"
                      ></app-toggle>
                    </div>

                    <div
                      class="col-sm-4 my-2 my-sm-0"
                      v-if="special_rate.status"
                    >
                      <div class="d-flex align-items-center">
                        <p class="txt--xs txt--off-white">Available</p>
                        <select
                          name="available_day"
                          id="available_day"
                          class="hidden_input hidden_input__lg custom-select"
                          v-model="special_rate.available"
                        >
                          <option value="1">Entire week</option>
                          <option value="2">Weekdays</option>
                          <option value="3">Weekends</option>
                          <option value="4">Custom</option>
                        </select>
                      </div>
                      <div v-if="special_rate.available == 4" class="mt-2">
                        <p class="txt--xs txt--off-white mb-2">Custom Days</p>
                        <v-select
                          class="style-chooser monthly-filter-select"
                          :class="{
                            'restrict-width': special_rate.available == 4,
                          }"
                          label="name"
                          :searchable="false"
                          :options="day_list"
                          :clearable="true"
                          :reduce="(name) => name.value"
                          placeholder="Select Days"
                          multiple
                          v-model="special_rate.custom_available_days"
                        ></v-select>
                      </div>
                      <div class="text-center d-flex align-items-center mt-1">
                        <p class="txt--xs txt--off-white">
                          Price
                          <span class="txt--primary font-weight-bold">$</span>
                        </p>
                        <input
                          type="text"
                          class="hidden_input hidden_input__lg"
                          v-model.number="special_rate.price"
                          @keypress="checkFloat"
                        />
                      </div>
                    </div>

                    <div class="col-sm-4" v-if="special_rate.status">
                      <div class="d-flex align-items-center">
                        <p class="txt--xs txt--off-white">Enter</p>
                        <select
                          class="hidden_input hidden_input__lg custom-select"
                          v-model="special_rate.start_type"
                          @change="checkSpecialRateEntryType(index)"
                        >
                          <option value="before">Before</option>
                          <option value="after">After</option>
                          <option value="between">Between</option>
                        </select>

                        <div
                          class="d-flex"
                          v-if="special_rate.start_type == 'between'"
                        >
                          <datetime
                            title="Start Time"
                            class="dateTime__picker"
                            type="time"
                            :input-class="['hidden_input', 'hidden_input__md']"
                            value-zone="local"
                            v-model="special_rate.start_date.start"
                          ></datetime>
                          <span class="mx-2 mt-1 txt--xs txt--off-white"
                            >to</span
                          >
                          <datetime
                            title="End Time"
                            class="dateTime__picker"
                            type="time"
                            :input-class="['hidden_input', 'hidden_input__md']"
                            value-zone="local"
                            v-model="special_rate.start_date.end"
                          ></datetime>
                        </div>
                        <div v-if="special_rate.start_type != 'between'">
                          <datetime
                            title="Start Time"
                            class="dateTime__picker"
                            type="time"
                            :input-class="['hidden_input', 'hidden_input__md']"
                            value-zone="local"
                            v-model="special_rate.start_date"
                          ></datetime>
                        </div>
                      </div>

                      <div class="d-flex align-items-center mt-1">
                        <p class="txt--xs txt--off-white">Exit</p>
                        <select
                          class="hidden_input hidden_input__lg custom-select"
                          v-model="special_rate.end_type"
                          @change="checkSpecialRateExitType(index)"
                        >
                          <option value="before">Before</option>
                          <option value="after">After</option>
                          <option value="between">Between</option>
                        </select>

                        <div
                          class="d-flex"
                          v-if="special_rate.end_type == 'between'"
                        >
                          <datetime
                            title="Start Time"
                            class="dateTime__picker"
                            type="time"
                            :input-class="['hidden_input', 'hidden_input__md']"
                            value-zone="local"
                            v-model="special_rate.end_date.start"
                          ></datetime>
                          <span class="mx-2 mt-1 txt--xs txt--off-white"
                            >to</span
                          >
                          <datetime
                            title="End Time"
                            class="dateTime__picker"
                            type="time"
                            :input-class="['hidden_input', 'hidden_input__md']"
                            value-zone="local"
                            v-model="special_rate.end_date.end"
                          ></datetime>
                        </div>
                        <div v-if="special_rate.end_type != 'between'">
                          <datetime
                            title="Start Time"
                            class="dateTime__picker"
                            type="time"
                            :input-class="['hidden_input', 'hidden_input__md']"
                            value-zone="local"
                            v-model="special_rate.end_date"
                          ></datetime>
                        </div>
                      </div>
                    </div>

                    <div
                      class="
                        col-sm-1
                        d-flex
                        align-items-center
                        justify-content-end
                      "
                    >
                      <p
                        class="opacity--25 cursor-pointer pricing__remove__txt"
                        @click="removeSpecialRate(index)"
                      >
                        REMOVE
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Add Special Rate Button -->
                <div class="d-flex">
                  <p
                    class="txt--ss opacity--25 cursor-pointer"
                    @click="addSpecialRate"
                  >
                    Add Special Rate
                  </p>
                </div>
              </div>

              <!-- Interval rate -->
              <div class="py-3 border--bottom-gray">
                <div v-if="price.interval_rate.length > 0">
                  <div
                    class="form-row align-items-center rate__row"
                    v-for="(interval, index) in price.interval_rate"
                    :key="index"
                  >
                    <div class="col-sm-3">
                      <app-toggle
                        :checked="interval.status"
                        :label="'Interval Rate'"
                        @update:checked="
                          updateIntervalRateStatus($event, index)
                        "
                      ></app-toggle>
                    </div>
                    <div
                      class="col-sm-4"
                      v-if="interval.status"
                      @click="openWindow('interval_add', index)"
                    >
                      <div class="d-flex align-items-center">
                        <p class="txt--xs txt--off-white">Duration</p>
                        <p class="txt--primary txt--xs pt-1 hidden_input">
                          {{ interval.duration }}
                        </p>
                      </div>
                    </div>
                    <div class="col-sm-3" v-if="interval.status">
                      <div
                        class="
                          text-center
                          d-flex
                          align-items-center
                          justify-content-sm-center
                        "
                      >
                        <p class="txt--xs txt--off-white">
                          Price
                          <span class="txt--primary font-weight-bold">$</span>
                        </p>
                        <input
                          type="text"
                          class="hidden_input hidden_input__lg"
                          v-model.number="interval.price"
                          @keypress="checkFloat"
                        />
                      </div>
                    </div>
                    <div
                      class="
                        col-sm-2
                        d-flex
                        align-items-center
                        justify-content-end
                      "
                    >
                      <p
                        class="opacity--25 cursor-pointer pricing__remove__txt"
                        @click="removeInterval(index)"
                      >
                        REMOVE
                      </p>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <p
                    class="txt--ss opacity--25 cursor-pointer"
                    @click="addInterval"
                  >
                    Add Interval Rate
                  </p>
                </div>
              </div>

              <!-- Special Event -->
              <div class="py-3 border--bottom-gray">
                <div v-if="price.special_event.length > 0">
                  <div
                    class="row no-gutters rate__row align-items-center"
                    v-for="(special_event, index) in price.special_event"
                    :key="index"
                  >
                    <div class="col-sm-3">
                      <app-toggle
                        :checked="special_event.enable"
                        :label="
                          special_event.name.length > 20
                            ? special_event.name.substring(0, 17) + '...'
                            : special_event.name
                        "
                        :label_clickable="true"
                        @label:clicked="updateSpecialEventLabel(index)"
                        @update:checked="
                          updateSpecialEventStatus($event, index)
                        "
                      ></app-toggle>
                    </div>
                    <div class="col-sm-3" v-if="special_event.enable">
                      <div class="d-flex align-items-center">
                        <p class="txt--xs txt--off-white">Start Date</p>
                        <datetime
                          title="Start Date"
                          class="dateTime__picker w-50"
                          :format="{
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                          }"
                          :input-class="['hidden_input', '']"
                          :min-datetime="minDatetime"
                          value-zone="local"
                          v-model="special_event.start_date"
                        ></datetime>
                      </div>

                      <div class="d-flex align-items-center mt-1">
                        <p class="txt--xs txt--off-white">End Date</p>
                        <datetime
                          title="End Date"
                          class="dateTime__picker w-50"
                          :format="{
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                          }"
                          :min-datetime="minDatetime"
                          :input-class="['hidden_input', '']"
                          value-zone="local"
                          v-model="special_event.end_date"
                        ></datetime>
                      </div>
                    </div>
                    <div class="col-sm-3" v-if="special_event.enable">
                      <div class="d-flex align-items-center">
                        <p class="txt--xs txt--off-white">Start Time</p>
                        <datetime
                          title="End Time"
                          class="dateTime__picker w-60"
                          type="time"
                          :input-class="['hidden_input', 'hidden_input__md']"
                          value-zone="local"
                          v-model="special_event.start_date"
                        ></datetime>
                      </div>

                      <div class="d-flex align-items-center mt-1">
                        <p class="txt--xs txt--off-white">End Time</p>
                        <datetime
                          title="End Time"
                          class="dateTime__picker w-60"
                          type="time"
                          :input-class="['hidden_input', 'hidden_input__md']"
                          value-zone="local"
                          v-model="special_event.end_date"
                        ></datetime>
                      </div>
                    </div>
                    <div class="col-sm-2" v-if="special_event.enable">
                      <div
                        class="
                          text-center
                          d-flex
                          align-items-center
                          justify-content-center
                          mt-1
                        "
                      >
                        <p class="txt--xs txt--off-white">
                          Price
                          <span class="txt--primary font-weight-bold">$</span>
                        </p>
                        <input
                          type="text"
                          class="hidden_input hidden_input__lg"
                          v-model.number="special_event.price"
                          @keypress="checkFloat"
                        />
                      </div>
                    </div>
                    <div
                      class="
                        col-sm-1
                        d-flex
                        align-items-center
                        justify-content-end
                      "
                    >
                      <p
                        class="opacity--25 cursor-pointer pricing__remove__txt"
                        @click="removeSpecialEvent(index)"
                      >
                        REMOVE
                      </p>
                    </div>
                  </div>
                </div>

                <div class="d-flex">
                  <p
                    class="txt--ss opacity--25 cursor-pointer"
                    @click="addSpecialEvent"
                  >
                    Add Special Event
                  </p>
                </div>
              </div>
              <!-- Parking Tax -->
              <div class="py-3"> <!--border--bottom-gray">-->
                <div class="row align-items-center">
                  <div class="col-sm-4">
                    <div class="d-flex align-items-center">
                      <p class="txt--ss mr-2">Parking Tax</p>
                      <div class="d-flex align-items-center">
                        <input
                          type="text"
                          id="parking_tax"
                          class="hidden_input hidden_input__lg text-right"
                          v-model.number="price.property_tax_rate"
                          @keypress="checkFloat"
                        />
                        <p class="txt--primary txt--xs font-weight-bold">%</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4 mt-sm-0">
                    <app-toggle
                      :checked="price.tax_included"
                      label="Tax Inclusive"
                      @update:checked="getChecked($event, 'tax_inclusive')"
                    ></app-toggle>
                  </div>
                </div>
              </div>

              <!-- Flat Amount/Service Charge -->
              <div class="pt-3 d-none">
                <div class="form-row align-items-center rate__row">
                  <div class="col-sm-3">
                    <p class="txt--ss">Service Charge</p>
                  </div>
                  <div class="col-sm-3">
                    <div
                      class="
                        text-center
                        d-flex
                        align-items-center
                        justify-content-sm-center
                      "
                    >
                      <p class="txt--xs txt--off-white">
                        Price
                        <span class="txt--primary font-weight-bold">$</span>
                      </p>
                      <input
                        type="text"
                        class="hidden_input hidden_input__lg"
                        v-model.number="price.service_charge"
                        @keypress="checkFloat"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Submit Button Section -->
      <div
      v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)"
      class="form-row">
        <div class="col-12">
          <div class="d-flex justify-content-center flex-wrap">
            <ButtonWithSpinner
              class="button button--primary button--sm mr-3"
              :loading="button.loading"
              :success="button.success"
              :disabled="button.disabled"
              @click="submitDetails"
              >Save</ButtonWithSpinner
            >
            <button
              type="button"
              class="button button--outline button--sm"
              @click="closeModal()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import ButtonWithSpinner from "@/components/Button";
import Toggle from "@/components/toggle";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
export default {
  components: {
    ButtonWithSpinner,
    AppToggle: Toggle,
    datetime: Datetime,
  },
  data() {
    return {
      button: {
        loading: false,
        success: false,
        disabled: false,
      },
      property_details: {},
      minDatetime: this.$moment("01/01/" + new Date().getFullYear()).format(
        "YYYY-MM-DDTHH:mm:ss.sssZ"
      ),
      price: {
        //Grace Period
        grace_period_status: false,
        grace_period: "15 mins",
        grace_period_duration: 900,
        //Special Rates
        special_rate: [],
        // Interval Rates
        interval_rate: [
          {
            duration: "1 min to 30 mins",
            duration_from: 60,
            duration_to: 1800,
            price: 0,
            status: true,
          },
        ],
        //Special Events
        special_event: [],
        //Parking Tax
        property_tax_rate: 0,
        tax_included: true,
        service_charge: 0,
      },
      day_list: [
        {
          name: "Monday",
          value: 1,
        },
        {
          name: "Tuesday",
          value: 2,
        },
        {
          name: "Wednesday",
          value: 3,
        },
        {
          name: "Thursday",
          value: 4,
        },
        {
          name: "Friday",
          value: 5,
        },
        {
          name: "Saturday",
          value: 6,
        },
        {
          name: "Sunday",
          value: 7,
        },
      ],
      user_role:    '',
      access_list:  {},
    };
  },
  computed: {
    computeModalWidth() {
      if (this.$mq === "lg") return "900px";
      else return "400px";
    },
  },
  created() {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list"));
  },
  mounted() {},
  methods: {
    //COMMON
    getData(e) {
      this.property_details = e.params.property_details;

      let property_price = JSON.parse(
        JSON.stringify(this.property_details.price)
      );
      // console.log("Property Price");
      // console.log(property_price);

      // Assign Data
      // Grace Period
      this.price.grace_period_status = !!property_price.grace_period_status;
      this.price.grace_period_duration = property_price.grace_period;
      this.price.grace_period = this.calculateDurationFromSeconds(
        property_price.grace_period
      );

      // Interval Rates
      if (property_price.interval_rate.length > 0) {
        this.price.interval_rate = [];
        property_price.interval_rate.map((val, key) => {
          if (val.duration_from && val.duration_to) {
            this.price.interval_rate.push({
              duration_from: val.duration_from,
              duration_to: val.duration_to,
              duration:
                this.calculateDurationFromSeconds(val.duration_from) +
                " to " +
                this.calculateDurationFromSeconds(val.duration_to),
              price: val.price.toFixed(2),
              status: !!val.status,
            });
          }
        });
      }

      // Special Rates
      if (property_price.special_rate.length > 0) {
        property_price.special_rate.map((val) => {
          let special_rate = {
            status: !!val.status,
            price: val.price,
            title: val.title,
            start_type: val.entry_type,
            end_type: val.exit_type,
            available: val.available,
            custom_available_days: val.custom_available_days
              ? val.custom_available_days
              : [],
          };

          if (special_rate.start_type == "between") {
            let e_h = val.entry.start.split(":")[0];
            let e_m = val.entry.start.split(":")[1];
            let e_d = new Date().setHours(e_h, e_m);

            let ex_h = val.entry.end.split(":")[0];
            let ex_m = val.entry.end.split(":")[1];
            let ex_d = new Date().setHours(ex_h, ex_m);

            special_rate.start_date = {
              start: this.$moment(e_d).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
              end: this.$moment(ex_d).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            };
          } else {
            let h = val.entry.split(":")[0];
            let m = val.entry.split(":")[1];
            let d = new Date().setHours(h, m);

            special_rate.start_date = this.$moment(d).format(
              "YYYY-MM-DDTHH:mm:ss.sssZ"
            );
          }

          if (special_rate.end_type == "between") {
            let e_h = val.exit.start.split(":")[0];
            let e_m = val.exit.start.split(":")[1];
            let e_d = new Date().setHours(e_h, e_m);

            let ex_h = val.exit.end.split(":")[0];
            let ex_m = val.exit.end.split(":")[1];
            let ex_d = new Date().setHours(ex_h, ex_m);

            special_rate.end_date = {
              start: this.$moment(e_d).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
              end: this.$moment(ex_d).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            };
          } else {
            let h = val.exit.split(":")[0];
            let m = val.exit.split(":")[1];
            let d = new Date().setHours(h, m);

            special_rate.end_date = this.$moment(d).format(
              "YYYY-MM-DDTHH:mm:ss.sssZ"
            );
          }

          this.price.special_rate.push(special_rate);
        });
      }
      // Special Events
      if (property_price.special_event.length > 0) {
        property_price.special_event.map((val, key) => {
          this.price.special_event.push({
            enable: !!val.special_event_status,
            price: val.special_event_price.toFixed(2),
            start_date:
              val.special_event_start_date != ""
                ? this.$moment(val.special_event_start_date).format(
                    "YYYY-MM-DDTHH:mm:ss.sssZ"
                  )
                : this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            end_date:
              val.special_event_end_date != ""
                ? this.$moment(val.special_event_end_date).format(
                    "YYYY-MM-DDTHH:mm:ss.sssZ"
                  )
                : this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            name: val.special_event_title
              ? val.special_event_title
              : `Special Event`,
          });
        });
      }
      //TAX & Service Charge
      this.price.property_tax_rate = property_price.property_tax_rate;
      this.price.tax_included = !!property_price.tax_included;
      this.price.service_charge = property_price.service_charge;
    },
    checkFloat(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      return true;
    },
    closeModal() {
      this.$emit("modal_closed");
      this.$modal.hide("property-pricing");
    },
    getChecked(checked, type) {
      if (type == "grace_period") {
        this.price.grace_period_status = checked;
      } else if (type == "tax_inclusive") {
        this.price.tax_included = checked;
      }
    },
    async openWindow(type, index) {
      const self = this;
      let hour = 0;
      let min = 0;

      if (type == "grace_period") {
        let seconds = this.price.grace_period_duration;
        hour = parseInt(seconds / 3600);

        if (hour < 0) {
          min = parseInt(seconds / 60);
        } else {
          seconds = seconds - hour * 3600;
          min = parseInt(seconds / 60);
        }

        const { value: duration } = await this.$swal({
          title: "Enter Duration!",
          html: `<div class="row justify-content-center">
                            <div class="col-sm-5">
                            <div class="d-flex justify-content-center align-items-center">
                                <p class="txt--xs txt--off-white">Hour:</p>
                                <input type="number" placeholder="Enter hour" class="hidden_input hidden_input__lg w-100" min="0" max="23" id="swal-hour" value="${hour}">
                            </div>
                            </div>
                            <div class="col-sm-5">
                            <div class="d-flex justify-content-center align-items-center">
                                <p class="txt--xs txt--off-white">Minute:</p>
                                <input type="number" placeholder="Enter minute" class="hidden_input hidden_input__lg w-100" min="0" max="59" id="swal-minute" value="${min}">
                            </div>
                            </div>
                        </div>`,
          showCancelButton: true,
          preConfirm: () => {
            let h = parseInt(document.getElementById("swal-hour").value);
            let m = parseInt(document.getElementById("swal-minute").value);
            if (h < 0) {
              self.$toasted.show("Invalid hour value", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (h > 23) {
              self.$toasted.show("Invalid hour value", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (m < 0) {
              self.$toasted.show("Invalid minute value", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (m > 59) {
              self.$toasted.show("Invalid minute value", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (isNaN(h) && isNaN(m)) {
              self.$toasted.show("Duration can not be empty!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (h == 0 && m == 0) {
              self.$toasted.show("Duration can not be zero!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (h == 0 && isNaN(m)) {
              self.$toasted.show("Duration can not be zero!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (isNaN(h) && m == 0) {
              self.$toasted.show("Duration can not be zero!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else {
              return {
                hour: h,
                min: m,
              };
            }
          },
        });

        if (duration != undefined) {
          this.price.grace_period = "";
          this.price.grace_period_duration = 0;

          if (duration.hour > 0) {
            this.price.grace_period =
              duration.hour > 1
                ? duration.hour + " hours "
                : duration.hour + " hour ";
            this.price.grace_period_duration = duration.hour * 3600;
          }

          if (duration.min > 0) {
            this.price.grace_period +=
              duration.min > 1 ? duration.min + " mins" : duration.min + " min";

            this.price.grace_period_duration += duration.min * 60;
          }
        }
      } else if (type == "interval_add") {
        let from_hour = 0;
        let to_hour = 0;
        let from_min = 0;
        let to_min = 0;

        let from_seconds = this.price.interval_rate[index].duration_from;
        let to_seconds = this.price.interval_rate[index].duration_to;

        from_hour = parseInt(from_seconds / 3600);
        to_hour = parseInt(to_seconds / 3600);

        if (from_hour < 0) {
          from_min = parseInt(from_seconds / 60);
        } else {
          from_seconds = from_seconds - from_hour * 3600;
          from_min = parseInt(from_seconds / 60);
        }

        if (to_hour < 0) {
          to_min = parseInt(to_seconds / 60);
        } else {
          to_seconds = to_seconds - to_hour * 3600;
          to_min = parseInt(to_seconds / 60);
        }

        const { value: duration } = await this.$swal({
          title: "Enter Duration!",
          html: `<div class="row">
                            <p class="txt--ss txt--off-white d-flex justify-content-start col-md-12">Duration From</p>
                            <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                    <p class="txt--xs txt--off-white">Hour:</p>
                                    <input type="number" placeholder="Enter hour" class="hidden_input hidden_input__lg w-100" min="0" max="23" id="swal-from-hour" value="${from_hour}">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                    <p class="txt--xs txt--off-white">Minute:</p>
                                    <input type="number" placeholder="Enter minute" class="hidden_input hidden_input__lg w-100" min="0" max="59" id="swal-from-minute" value="${from_min}">
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <p class="txt--ss txt--off-white d-flex justify-content-start col-md-12">Duration To</p>
                            <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                    <p class="txt--xs txt--off-white">Hour:</p>
                                    <input type="number" placeholder="Enter hour" class="hidden_input hidden_input__lg w-100" min="0" max="23" id="swal-to-hour" value="${to_hour}">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                    <p class="txt--xs txt--off-white">Minute:</p>
                                    <input type="number" placeholder="Enter minute" class="hidden_input hidden_input__lg w-100" min="0" max="59" id="swal-to-minute" value="${to_min}">
                                </div>
                            </div>
                        </div>`,
          showCancelButton: true,
          preConfirm: () => {
            let from_hour = parseInt(
              document.getElementById("swal-from-hour").value
            );
            let from_min = parseInt(
              document.getElementById("swal-from-minute").value
            );
            let to_hour = parseInt(
              document.getElementById("swal-to-hour").value
            );
            let to_min = parseInt(
              document.getElementById("swal-to-minute").value
            );

            if (
              (isNaN(from_hour) && isNaN(from_min)) ||
              (isNaN(to_hour) && isNaN(to_min))
            ) {
              self.$toasted.show("Duration can not be empty!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            }

            if (
              (from_hour == 0 && isNaN(from_min)) ||
              (isNaN(from_hour) && from_min == 0) ||
              (to_hour == 0 && isNaN(to_min)) ||
              (isNaN(to_hour) && to_min == 0) ||
              (from_hour == 0 && from_min == 0) ||
              (to_hour == 0 && to_min == 0)
            ) {
              self.$toasted.show("Duration can not be zero!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            }

            if (from_hour < 0 || to_hour < 0) {
              self.$toasted.show("Invalid hour value", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            }

            if (from_hour > 23 || to_hour > 23) {
              self.$toasted.show("Invalid hour value", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            }

            if (from_min < 0 || to_min < 0 || from_min > 59 || to_min > 59) {
              self.$toasted.show("Invalid minute value", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            }

            if (from_hour > to_hour) {
              self.$toasted.show("Invalid Duration value!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            }

            if (from_hour == to_hour && from_min > to_min) {
              self.$toasted.show("Invalid Duration value!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            }

            return {
              from_hour: isNaN(from_hour) ? 0 : from_hour,
              to_hour: isNaN(to_hour) ? 0 : to_hour,
              from_min: isNaN(from_min) ? 0 : from_min,
              to_min: isNaN(to_min) ? 0 : to_min,
            };
          },
        });

        if (duration != undefined) {
          // console.log(duration);
          this.price.interval_rate[index].duration = "";
          this.price.interval_rate[index].duration_from = 0;
          this.price.interval_rate[index].duration_to = 0;

          let from_duration =
            duration.from_hour * 3600 + duration.from_min * 60;
          let to_duration = duration.to_hour * 3600 + duration.to_min * 60;

          this.price.interval_rate[index].duration_from = from_duration;
          this.price.interval_rate[index].duration_to = to_duration;

          if (duration.from_hour > 0) {
            this.price.interval_rate[index].duration +=
              duration.from_hour > 1
                ? duration.from_hour + " hours "
                : duration.from_hour + " hour ";
          }
          if (duration.from_min > 0) {
            this.price.interval_rate[index].duration +=
              duration.from_min > 1
                ? duration.from_min + " mins "
                : duration.from_min + " min ";
          }

          this.price.interval_rate[index].duration += " to ";

          if (duration.to_hour > 0) {
            this.price.interval_rate[index].duration +=
              duration.to_hour > 1
                ? duration.to_hour + " hours "
                : duration.to_hour + " hour ";
          }
          if (duration.to_min > 0) {
            this.price.interval_rate[index].duration +=
              duration.to_min > 1
                ? duration.to_min + " mins "
                : duration.to_min + " min ";
          }
        }
      }
    },
    calculateDurationFromSeconds(seconds) {
      let hour = 0;
      let min = 0;
      let duration = "";
      hour = parseInt(seconds / 3600);

      if (hour > 0) {
        duration += hour > 1 ? hour + " hours" : hour + " hour ";
        seconds = seconds - hour * 3600;
        min = parseInt(seconds / 60);
        duration += min > 1 ? min + " mins " : min + " min ";
      } else {
        min = parseInt(seconds / 60);
        duration += min > 1 ? min + " mins " : min + " min ";
      }

      return duration;
    },
    //Special Rates
    async addSpecialRate() {
      const { value: specialEvent } = await this.$swal({
        title: "Special Rate Name",
        input: "text",
        inputValue: "Special Rate",
        inputPlaceholder: "Enter Special Rate Name",
        showCancelButton: true,
        preConfirm: (value) => {
          if (!value) {
            this.$toasted.show("Please enter a Special Rate Name!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          }
        },
      });
      if (specialEvent) {
        this.price.special_rate.push({
          status: true,
          title: specialEvent,
          start_date: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          end_date: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          start_type: "after",
          end_type: "before",
          price: 0,
          available: 1,
          custom_available_days: [],
        });
      }
    },
    updateSpecialRateStatus(checked, index) {
      this.price.special_rate[index].status = checked;
    },
    removeSpecialRate(index) {
      this.$delete(this.price.special_rate, index);
    },
    async updateSpecialRateLabel(index) {
      const { value: specialEvent } = await this.$swal({
        title: "Special Rate Name",
        input: "text",
        inputValue: this.price.special_rate[index].title,
        inputPlaceholder: "Enter Special Rate Name",
        showCancelButton: true,
        preConfirm: (value) => {
          if (!value) {
            this.$toasted.show("Please enter a Special Rate Name!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          }
        },
      });
      if (specialEvent) {
        this.price.special_rate[index].title = specialEvent;
      }
    },
    checkSpecialRateEntryType(index) {
      if (this.price.special_rate[index].start_type != "between") {
        this.price.special_rate[index].start_date = this.$moment().format(
          "YYYY-MM-DDTHH:mm:ss.sssZ"
        );
      } else {
        this.price.special_rate[index].start_date = null;
        this.price.special_rate[index].start_date = JSON.parse(
          JSON.stringify({
            start: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            end: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          })
        );
      }
    },
    checkSpecialRateExitType(index) {
      if (this.price.special_rate[index].end_type != "between") {
        this.price.special_rate[index].end_date = this.$moment().format(
          "YYYY-MM-DDTHH:mm:ss.sssZ"
        );
      } else {
        this.price.special_rate[index].end_date = null;
        this.price.special_rate[index].end_date = JSON.parse(
          JSON.stringify({
            start: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            end: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          })
        );
      }
    },
    //Interval Rate
    addInterval() {
      this.price.interval_rate.push({
        duration: "1 min to 30 mins",
        duration_from: 60,
        duration_to: 1800,
        price: 0,
        status: true,
      });
    },
    removeInterval(index) {
      this.$delete(this.price.interval_rate, index);
    },
    updateIntervalRateStatus(check, index) {
      this.price.interval_rate[index].status = check;
    },
    //Special Events
    async addSpecialEvent() {
      const { value: specialEvent } = await this.$swal({
        title: "Special Event Name",
        input: "text",
        inputValue: `Special Event ${this.price.special_event.length + 1}`,
        inputPlaceholder: "Enter Special Event Name",
        showCancelButton: true,
        preConfirm: (value) => {
          if (!value) {
            this.$toasted.show("Please enter a Special Event Name!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          }
        },
      });
      if (specialEvent) {
        this.price.special_event.push({
          name: specialEvent,
          enable: true,
          price: 1,
          start_date: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          end_date: this.$moment()
            .add(1, "days")
            .format("YYYY-MM-DDTHH:mm:ss.sssZ"),
        });
      }
    },
    updateSpecialEventStatus(checked, index) {
      this.price.special_event[index].enable = checked;
    },
    async updateSpecialEventLabel(index) {
      const { value: specialEvent } = await this.$swal({
        title: "Special Event Name",
        input: "text",
        inputValue: this.price.special_event[index].name,
        inputPlaceholder: "Enter Special Event Name",
        showCancelButton: true,
        preConfirm: (value) => {
          if (!value) {
            this.$toasted.show("Please enter a Special Event Name!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          }
        },
      });
      if (specialEvent) {
        this.price.special_event[index].name = specialEvent;
      }
    },
    removeSpecialEvent(index) {
      this.$delete(this.price.special_event, index);
    },
    submitDetails() {
      // Validate Data
      // Validate Grace Period
      if (this.grace_period_status && this.grace_period_duration <= 0) {
        this.$toasted.show("Please provide a valid grace period duration!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      // Validate Special Event
      if (this.price.special_event.length > 0) {
        let error = false;
        this.price.special_event.map((val) => {
          if (val.enable) {
            if (val.start_date == "" || val.end_date == "") {
              this.$toasted.show(
                val.name + " event start date and end date is required!",
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
              error = true;
            }
            //Check Start Time Is Greater Than End Time Or Not
            let start = this.$moment(val.start_date);
            let end = this.$moment(val.end_date);

            if (start.diff(end) > 0) {
              this.$toasted.show(
                val.name + " event start date can not be greater than end date",
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
              error = true;
            }
            if (isNaN(val.price)) {
              this.$toasted.show(val.name + " event price is invalid!", {
                icon: "times-circle",
                className: "error-class",
              });
              error = true;
            }
          }
        });

        if (error) {
          return;
        }
      }
      // Validate Special Rate
      if (this.price.special_rate.length > 0) {
        let error = false;
        this.price.special_rate.map((val) => {
          if (val.status) {
            if (isNaN(val.price)) {
              this.$toasted.show(
                val.title + " special rate price is invalid!",
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
              error = true;
            }

            if (val.available == 4 && val.custom_available_days.length == 0) {
              this.$toasted.show(
                "Please select days of the week for the special rate " +
                  val.title,
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
              error = true;
            }
          }
        });
        if (error) {
          return;
        }
      }
      // Validate Interval Rate
      if (this.price.interval_rate.length > 0) {
        let error = true;
        this.price.interval_rate.map((val) => {
          if (val.status) {
            error = false;
          }
        });

        if (error) {
          this.$toasted.show("At least one active interval rate is required!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
        }
      } else {
        this.$toasted.show("Please provide at least one interval rate!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      // Validate Tax Rate
      if (
        this.price.property_tax_rate > 100 ||
        this.price.property_tax_rate < 0
      ) {
        this.$toasted.show("Property Tax Rate value is invalid!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      // Validate Service Charge
      if (this.price.service_charge < 0) {
        this.$toasted.show("Please provide a valid Service Charge amount!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      // Validation Passed => Format Data, Call API
      this.button.disabled = true;
      this.button.loading = true;

      let submitData = {};

      submitData.space_id = this.property_details.space_id;
      submitData.monthly_application_fee =
        this.property_details.monthly_application_fee;
      submitData.application_fee_type =
        this.property_details.application_fee_type;
      submitData.device_type = 1;
      submitData.mode = "price";
      submitData.commercial = 1;

      //Grace Period Data Entry
      submitData.grace_period_status = this.price.grace_period_status ? 1 : 0;
      submitData.grace_period = this.price.grace_period_duration;

      //Special Events
      submitData.special_event = [];
      if (this.price.special_event.length > 0) {
        this.price.special_event.map((val) => {
          submitData.special_event.push({
            special_event_status: val.enable ? 1 : 0,
            title: val.name ? val.name : "",
            special_event_price: val.price ? parseFloat(val.price) : 0,
            special_event_start_date:
              val.start_date && val.start_date != ""
                ? this.$moment(val.start_date).format("YYYY-MM-DD HH:mm:ss")
                : null,
            special_event_end_date:
              val.end_date && val.end_date != ""
                ? this.$moment(val.end_date).format("YYYY-MM-DD HH:mm:ss")
                : null,
          });
        });
      }

      // Special Rate
      submitData.special_rate = [];
      // // console.log("Special Rate Before Format",this.price.special_rate);
      if (this.price.special_rate.length > 0) {
        this.price.special_rate.map((val) => {
          let formatted_special_rate = {
            status: val.status ? 1 : 0,
            title: val.title ? val.title : "",
            price: val.price ? val.price : 0,
            available: val.available,
            entry_type: val.start_type,
            exit_type: val.end_type,
            custom_available_days: val.custom_available_days,
          };

          if (val.start_type != "between") {
            formatted_special_rate.entry = this.$moment(val.start_date).format(
              "HH:mm"
            );
          } else {
            formatted_special_rate.entry = {
              start: this.$moment(val.start_date.start).format("HH:mm"),
              end: this.$moment(val.start_date.end).format("HH:mm"),
            };
          }
          if (val.end_type != "between") {
            formatted_special_rate.exit = this.$moment(val.end_date).format(
              "HH:mm"
            );
          } else {
            formatted_special_rate.exit = {
              start: this.$moment(val.end_date.start).format("HH:mm"),
              end: this.$moment(val.end_date.end).format("HH:mm"),
            };
          }

          submitData.special_rate.push(formatted_special_rate);
        });
      }

      // Interval Rate
      submitData.interval_rate = [];
      if (this.price.interval_rate.length > 0) {
        this.price.interval_rate.map((val) => {
          submitData.interval_rate.push({
            status: val.status ? 1 : 0,
            duration_from: val.duration_from,
            duration_to: val.duration_to,
            price: val.price,
          });
        });
      }

      //Tax Rate And Service Charge
      submitData.property_tax_rate = parseFloat(this.price.property_tax_rate);
      submitData.tax_included = this.price.tax_included ? 1 : 0;
      submitData.service_charge = parseFloat(this.price.service_charge);
      this.axios
        .post(window.hostname + "api/auth/create-space", submitData)
        .then((res) => {
          // console.log(res);
          if (res.data.status) {
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = true;
            this.$toasted.show("Property price updated successfully!", {
              icon: "check-circle",
              className: "success-class",
            });

            this.closeModal();

            // if(res.data.monthly_price_updated)
            // {
            // this.throwEmail();
            // }
          } else {
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = false;
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((err) => {
          // console.log(err);
          this.button.disabled = false;
          this.button.loading = false;
          this.button.success = false;
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
  },
};
</script>
<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
.hidden_input__lg.custom-select {
  width: 100px !important ;
}
select option {
  background: #121212;
  border: none;
  margin: 40px;
}
.restrict-width {
  width: 200px !important;
}
</style>